import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectAudioLanguages } from '@/redux/selectors/constantsSelectors';
import SimpleLabelValue from '@/components/_common/SimpleLabelValue';
import SchemaFormatBox from '@/components/_common/SchemaForm/SchemaFormatBox';
import { ProfileChip } from '@/components/OrderPlacement/OPStep1OrderDetails/OPProfileDetailsOutput';

type AudioBoxProps = {
  value: string[];
};

const AudioBox = ({ value }: AudioBoxProps) => {
  const AudioLanguages = useAppSelector(selectAudioLanguages);

  return (
    <SchemaFormatBox label="audio">
      <StyledDiv>
        {value?.map((track, i) => {
          const lang = AudioLanguages?.find((l) => l.code.replace('_', '-') === track);
          return (
            <ProfileChip
              isSchema
              key={track}
              color="secondary"
              label={`Track ${i + 1}`}
              value={SimpleLabelValue({ label: lang?.label, value: track, fallback: track })}
            />
          );
        })}
      </StyledDiv>
    </SchemaFormatBox>
  );
};

export default AudioBox;

const StyledDiv = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'flex-start'
}));
